import { useEffect, useState } from 'react';

import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import type { ApiVolopFunction } from '#/api/types/ApiVolopFunction';
import { useIsUsingAlgoliaMock } from '#/config/AppConfigContext';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchAlgoliaFetchRecommendedVolops } from '#/modules/search/algolia/fetch/searchAlgoliaFetchRecommendedVolops';
import type { SearchAlgoliaRecommendedListingHit } from '#/modules/search/algolia/types/SearchAlgoliaRecommendedListingHit';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import { log } from '#/utils/logging';

/*
 * Fetch recommended actions
 */
export function useSearchAlgoliaRecommendedVolops(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  options?: {
    volopFunction?: ApiVolopFunction | null;
    areaOfFocus?: ApiAreaOfFocus | null;
    locale?: I18nLocale | 'all';
  },
) {
  const { isUsingAlgoliaMock } = useIsUsingAlgoliaMock();

  // @ts-expect-error TS(2339): Property 'volopFunction' does not exist on type '{ ... Remove this comment to see the full error message
  const { volopFunction, areaOfFocus, locale } = options;

  const [data, setData] = useState<SearchAlgoliaRecommendedListingHit[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    searchAlgoliaFetchRecommendedVolops(
      searchLocation,
      { distinct: true },
      {
        volopFunction,
        areaOfFocus,
        locale,
      },
      isUsingAlgoliaMock,
    )
      .then((hits) => setData(hits))
      .catch((e) => {
        setError(e);
        log.error(e);
      })
      .finally(() => setIsLoading(false));
  }, [searchLocation, volopFunction, areaOfFocus, locale, isUsingAlgoliaMock]);

  return { data, isLoading, error };
}
